module.exports = __webpack_public_path__ + "public/SiteImages/defaultPic.png?04ed1861";